// @ts-nocheck
import {InitPage} from "../index";

class AssetMovements {
  constructor() {
    $('document').ready(function () {
      $('#from_date, #to_date').datepicker({ format: 'yyyy-mm-dd HH:ii p' });
      $('#from-date').on('click', function (e) {
        e.preventDefault();
        $('#from_date').datepicker('show');
      });
      $('#to-date').on('click', function (e) {
        e.preventDefault();
        $('#to_date').datepicker('show');
      })
    });
  }
}

export function LoadPage() {
  InitPage("asset_movements index", () => {
    const c = new AssetMovements();
  });
}
